function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { compact } from 'lodash-es';
import { routes } from "../../constants";
import { relationshipModel, UserRole } from "../../models";
import { hasClientViewPermission, RelationshipStatus } from "../../models/relationship";
import { formatDateTimeWithLongMonth } from "../../utils";
import { getTimezoneAbbreviation } from "../../utils/date-timezone.utils";
export let PreviewState = /*#__PURE__*/function (PreviewState) {
  PreviewState["Preview"] = "preview";
  PreviewState["SetupBrand"] = "setupBrand";
  return PreviewState;
}({});
export let COBStep = /*#__PURE__*/function (COBStep) {
  COBStep["welcome"] = "welcome";
  COBStep["selectAPackage"] = "packages";
  COBStep["reviewServices"] = "services";
  COBStep["termsOfService1"] = "terms-of-service-1";
  COBStep["termsOfService2"] = "terms-of-service-2";
  COBStep["termsOfService3"] = "terms-of-service-3";
  COBStep["termsOfService4"] = "terms-of-service-4";
  COBStep["approveTerms"] = "terms";
  COBStep["accountantAccess"] = "accountant-access";
  COBStep["paymentMethod"] = "payment-method";
  COBStep["introVideo"] = "intro-video";
  COBStep["allSet"] = "all-set";
  return COBStep;
}({});
export const termsOfServiceStepIndex = {
  [COBStep.termsOfService1]: 0,
  [COBStep.termsOfService2]: 1,
  [COBStep.termsOfService3]: 2,
  [COBStep.termsOfService4]: 3
};
export function getStepName(step, relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  const getTermsOfServiceName = index => {
    var _relationship$legalTe, _relationship$legalTe2;
    return "Review ".concat((_relationship$legalTe = (_relationship$legalTe2 = relationship.legalTermsDocuments) === null || _relationship$legalTe2 === void 0 || (_relationship$legalTe2 = _relationship$legalTe2[index]) === null || _relationship$legalTe2 === void 0 ? void 0 : _relationship$legalTe2.displayName.replace(/\.pdf$/i, '')) !== null && _relationship$legalTe !== void 0 ? _relationship$legalTe : '');
  };
  switch (step) {
    case COBStep.welcome:
      return 'Introduction';
    case COBStep.selectAPackage:
      return 'Select a Package';
    case COBStep.reviewServices:
      return 'Review Services';
    case COBStep.approveTerms:
      return MULTIPLE_LEGAL_TERMS_DOCUMENTS ? 'Review Additional Terms' : 'Review Terms';
    case COBStep.accountantAccess:
      return 'Grant Accountant Access';
    case COBStep.paymentMethod:
      return 'Add a Payment Method';
    case COBStep.allSet:
      return "You're all set!";
    case COBStep.introVideo:
      return 'Welcome video';
    case COBStep.termsOfService1:
      return getTermsOfServiceName(0);
    case COBStep.termsOfService2:
      return getTermsOfServiceName(1);
    case COBStep.termsOfService3:
      return getTermsOfServiceName(2);
    case COBStep.termsOfService4:
      return getTermsOfServiceName(3);
  }
}
export function getReachableSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  var _relationship$legalTe3, _relationship$legalTe4;
  const hasPaymentMethod = relationship.requirePaymentMethod || relationship.isSample;
  const hasPackages = !!relationship.serviceBundles;
  const termsOfServiceSteps = MULTIPLE_LEGAL_TERMS_DOCUMENTS ? [COBStep.termsOfService1, COBStep.termsOfService2, COBStep.termsOfService3, COBStep.termsOfService4] : [];
  const termsOfServiceCount = (_relationship$legalTe3 = (_relationship$legalTe4 = relationship.legalTermsDocuments) === null || _relationship$legalTe4 === void 0 ? void 0 : _relationship$legalTe4.length) !== null && _relationship$legalTe3 !== void 0 ? _relationship$legalTe3 : 0;
  while (termsOfServiceSteps.length > termsOfServiceCount) {
    termsOfServiceSteps.pop();
  }
  return compact([COBStep.welcome, relationshipModel.hasIntroVideos(relationship) && COBStep.introVideo, hasPackages && COBStep.selectAPackage, COBStep.reviewServices, ...termsOfServiceSteps, COBStep.approveTerms, hasPaymentMethod && COBStep.paymentMethod, COBStep.allSet]);
}
export let Reason = /*#__PURE__*/function (Reason) {
  Reason["PaymentMethod"] = "payment-method";
  Reason["ReviewServices"] = "services";
  Reason["SelectAPackage"] = "packages";
  Reason["ApproveTermsOfServices"] = "approveTermsOfServices";
  Reason["ReviewerApprove"] = "reviewerApprove";
  return Reason;
}({});
export const reasonToText = {
  [Reason.PaymentMethod]: 'To approve the agreement, Please add a payment method.',
  [Reason.ReviewServices]: 'To approve the agreement, It is required to select at least one service.',
  [Reason.SelectAPackage]: 'To approve the agreement, Please select a package.',
  [Reason.ReviewerApprove]: 'You can view and interact with the proposal, but not approve it.',
  [Reason.ApproveTermsOfServices]: 'To approve the agreement, Please agree to the Terms of Service.'
};
export const getNextStepButtonText = (step, relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) => {
  const reachableSteps = getReachableSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS);
  const currentStepIndex = reachableSteps.indexOf(step);
  if (currentStepIndex === -1) {
    throw new Error('Unreachable step');
  }
  const nextStep = reachableSteps[currentStepIndex + 1];
  if (!nextStep) {
    throw new Error('should have next step');
  }
  if (nextStep === COBStep.selectAPackage) {
    return 'Select a Package';
  }
  if (nextStep === COBStep.paymentMethod) {
    return 'Add payment method';
  }
  switch (step) {
    case COBStep.welcome:
      return relationship.isSample ? 'Review test agreement' : 'Review the agreement';
    default:
      return 'Next';
  }
};
export const getInitialSelectedBundleId = (getFromStorage, relationship, userId) => {
  const fromStorage = getFromStorage('selected_bundle_id');
  if (fromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
    return fromStorage;
  }
  return relationshipModel.selectedBundleId(relationship) || undefined;
};
export const getInitialSelectedOptionalServices = _ref => {
  let {
    setToStorage,
    getFromStorage,
    isPreview,
    relationship,
    selectedBundleID,
    userId
  } = _ref;
  const getInitialSelectedOptionalServices = () => {
    const initialSelectedOptionalServices = relationshipModel.includedByDefaultOptionalServices(relationship, selectedBundleID);
    setToStorage('selected_optional_services', initialSelectedOptionalServices);
    return initialSelectedOptionalServices;
  };
  const fromStorage = getFromStorage('selected_optional_services');
  const fromRelationship = relationshipModel.selectedOptionalServices(relationship);
  const hasSelectedOptionalServices = fromRelationship.length > 0;
  if (isPreview) {
    return getInitialSelectedOptionalServices();
  }
  if (fromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
    return fromStorage;
  }
  if (hasSelectedOptionalServices) {
    setToStorage('selected_optional_services', fromRelationship);
    return fromRelationship;
  }
  return getInitialSelectedOptionalServices();
};
export const getInitialSelectedPaymentMethod = (getFromStorage, relationship, userId) => {
  const selectedPaymentFromStorage = getFromStorage('selected_payment_method');
  if (selectedPaymentFromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
    return selectedPaymentFromStorage;
  } else {
    return {
      fundingSourceId: relationshipModel.selectedFundingSourceId(relationship) || undefined
    };
  }
};
export function isApproveProposalDisabled(disabled, disabledReason, userId, relationship) {
  if (!disabled && relationshipModel.isSignatory(relationship, userId)) {
    return false;
  }
  return disabled || !!disabledReason;
}
export const getPrimaryRelationshipApprovedNavigateUrl = _ref2 => {
  let {
    relationshipId,
    hasEnteredWizard
  } = _ref2;
  return hasEnteredWizard ? routes.allSet(relationshipId) : routes.agreement(relationshipId);
};
export const getSignatoryRelationshipApprovedNavigateUrl = _ref3 => {
  let {
    hasEnteredWizard,
    role,
    relationshipId
  } = _ref3;
  if (hasEnteredWizard) {
    return routes.allSignaturesAcquired;
  }
  if (!hasClientViewPermission(role)) {
    return routes.noPermissionsRelationshipAlreadyApproved;
  } else {
    return routes.agreement(relationshipId);
  }
};
const getUrl = _ref4 => {
  let {
    relationshipStatus,
    hasStartedWithPendingStatus,
    isPrimary,
    relationshipId,
    role,
    vendorName,
    isVendor
  } = _ref4;
  switch (relationshipStatus) {
    case RelationshipStatus.Approved:
      return {
        url: isPrimary ? getPrimaryRelationshipApprovedNavigateUrl({
          relationshipId,
          hasEnteredWizard: hasStartedWithPendingStatus
        }) : getSignatoryRelationshipApprovedNavigateUrl({
          relationshipId,
          role,
          hasEnteredWizard: hasStartedWithPendingStatus
        })
      };
    case RelationshipStatus.Terminated:
      if (hasClientViewPermission(role)) {
        return {
          url: routes.agreement(relationshipId)
        };
      }
      return null;
    case RelationshipStatus.Canceled:
      return {
        url: routes.canceledProposalPage
      };
    case RelationshipStatus.Pending:
      return null;
    case RelationshipStatus.Expired:
      {
        if (isVendor) return null;
        const state = {
          vendorName
        };
        return {
          url: routes.expiredProposalPage,
          state
        };
      }
  }
};
export function clientOnboardingNavigateStateReducer(state, action) {
  const newState = _objectSpread({}, state);
  switch (action.type) {
    case 'RelationshipStatusChanged':
      newState.relationshipStatus = action.status;
      break;
    default:
      return state;
  }
  const value = getUrl({
    relationshipStatus: newState.relationshipStatus,
    hasStartedWithPendingStatus: newState.hasStartedWithPendingStatus,
    isPrimary: newState.isPrimary,
    relationshipId: newState.relationshipId,
    role: newState.role,
    vendorName: newState.vendorName,
    isVendor: newState.isVendor
  });
  newState.urlToNavigate = (value === null || value === void 0 ? void 0 : value.url) || null;
  newState.state = value === null || value === void 0 ? void 0 : value.state;
  return newState;
}
export function isAllowedToGoBack(url) {
  return url === routes.canceledProposalPage;
}
export function getIsAllowedToSIgn(_ref5) {
  let {
    relationship,
    userId,
    role
  } = _ref5;
  if (relationshipModel.hasSignatories(relationship)) {
    return relationshipModel.isSignatory(relationship, userId) || relationshipModel.isBuyer(relationship, userId);
  } else {
    return relationshipModel.isBuyer(relationship, userId) || role === UserRole.Owner;
  }
}
export function getExpirationDateMessage(expirationDate) {
  if (!expirationDate) return null;

  //im adding +1 to the day because the offer expired at the END of the chosen expiration date
  //if i won't add +1, resetting the time to midnight will be the biginning of this day
  const utcMidnight = new Date(Date.UTC(expirationDate.year, expirationDate.month - 1, expirationDate.day + 1, 0, 0, 0, 0));
  const timezoneAbbreviation = getTimezoneAbbreviation(utcMidnight);
  return "Discounted rates apply if this proposal is approved by ".concat(formatDateTimeWithLongMonth(utcMidnight), " (").concat(timezoneAbbreviation || 'your timezone', ").");
}